export default __webpack_public_path__ + "static/media/pic1.922d9a95.jpg";